import React from 'react';
import LocationTemplate from './LocationTemplate';

const WarrentonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Warrenton"
      stateName="North Carolina"
      countyName="Warren"
      zipCodes={["27589"]}
      latitude={36.3988}
      longitude={-78.1539}
      population={862}
      historicalFact="Founded in 1779, named after Joseph Warren who died at the Battle of Bunker Hill."
      nearbyTowns={[
        "Henderson, NC",
        "Louisburg, NC",
        "Oxford, NC",
        "Norlina, NC",
        "Macon, NC",
        "Soul City, NC",
        "Littleton, NC",
        "Weldon, NC"
      ]}
    />
  );
};

export default WarrentonPage;